import { SharedConstants } from "./shared.constants";
export class MapServiceConstants {
    static MODULE_ID_FILTER_STRING = "moduleId eq  ";
    static REMOVE_TITLE = `${SharedConstants.REMOVE_TITLE} map service`;
    static REMOVE_MESSAGE = `${SharedConstants.REMOVE_MESSAGE} map service(s)?`;
    static EDIT_TITLE = "Edit Map Service";
    static ADD_TITLE = "Add Map Service";
    static NAME_FORM_CONTROL = "name";
    static TYPE_FORM_CONTROL = "type";
    static URL_FORM_CONTROL = "url";
    static IS_AUTHENTICATED_CONTROL = "isAuth";
    static AUTH_TYPE_CONTROL = "authType";
    static CLIENT_ID_CONTROL = "clientId";
    static SECRET_CONTROL = "secret";
    static USERNAME_CONTROL = "username";
    static PASSWORD_CONTROL = "password";
    static MAP_ORDER_CONTROL = "mapOrder";
    static SELECTION_LAYER_CONTROL = "selectionLayerType";
    static DEFAULT_VISIBILITY_CONTROL = "defaultVisibility";
    static SHOW_POPUPS_CONTROL = "showPopups";
    static NAME_FORM_TEXT = "Service name";
    static TYPE_FORM_TEXT = "Service type";
    static URL_FORM_TEXT = "Map shared-services url";
    static IS_AUTHENTICATED_TEXT = "Service is authenticated";
    static AUTH_TYPE_TEXT = "Authentication type";
    static CLIENT_ID_TEXT = "Client ID";
    static SECRET_TEXT = "Secret";
    static USERNAME_TEXT = "Username";
    static PASSWORD_TEXT = "Password";
    static MAP_ORDER_TEXT = "Map order";
    static SELECTION_LAYER_TEXT = "Selection layer";
    static DEFAULT_VISIBILITY_TEXT = "Default visibility";
    static SHOW_POPUPS_TEXT = "Show popups";
    static NAME_FORM_PLACEHOLDER = "e.g. TownPlanningBaseMap";
    static TYPE_FORM_PLACEHOLDER = "Choose your option";
    static URL_FORM_PLACEHOLDER = "e.g.https://sampleserver.arcgisonline.com/ArcGIS/rest/services/Townplanning/MapServer";
    static AUTH_TYPE_FORM_PLACEHOLDER = SharedConstants.PLACEHOLDER_TEXT;
    static CLIENT_ID_FORM_PLACEHOLDER = "e.g. 1234";
    static SECRET_FORM_PLACEHOLDER = "e.g. xxxx";
    static USERNAME_FORM_PLACEHOLDER = "e.g. John117";
    static PASSWORD_FORM_PLACEHOLDER = "e.g. xxxx";
    static MAP_SERVICE_TEXT = "Map shared-services";
    static INVALID_ESRI_URL = "Url not a valid Esri endpoint";
    static INVALID_ESRI_AUTH = "Map shared-services authentication failed";
    static DUPLICATE_NAME_MESSAGE = "A map shared-services with the provided name already exists. Please supply a new name.";
    static DUPLICATE_URL_MESSAGE = "A map shared-services with the provided url already exists, Please supply a new url.";
    static PROPERTY_LAYER = "Property";
    static PROPERTY_OWNER_LAYER = "Property owner";
    static PROPERTY_ZONING_LAYER = "Property zone";
    static CEMETERY_LAYER = "Cemetery";
    static GRAVE_LAYER = "Grave";
    static SERVICE_NAME_MAX_LENGTH = 150;
    static APPLICATION_LAYER = "Application";
    static AFLA_PORTAL_APPLICATION_LAYER = "AFLA Portal Application";
    static APPLICATION_LAYER_ID_COLUMN = "JobID";
}
export const validationMessage = {
    url: {
        required: `Url ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        pattern: "Not a valid url format"
    },
    type: {
        required: `Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    name: {
        required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxLength: `Name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`
    },
    authType: {
        required: `Authentication Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    clientId: {
        required: `Client Id ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    secret: {
        required: `Secret ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    username: {
        required: `Username ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    password: {
        required: `Password ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    mapOrder: {
        required: `Map order ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    selectionLayerType: {
        required: `Selection Layer Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
};
